<template lang="">
    <div id='chart' class='bg-site-primary p-2'  v-if="userInfo.cleanEntries && Object.keys(userInfo.cleanEntries ).length > 0 ">
        <apexchart type="area" height="200" :options="chartOptions" :series="series"></apexchart>
</div>
</template>
<script setup>
import { ref, computed } from 'vue';
import { UserInfo } from '@/stores/UserInfo';

const userInfo = ref(UserInfo());


const parseDate = (dateString) => {
  const [day, month, year] = dateString.split('-').map(Number);
  return new Date(year, month - 1, day).getTime();
};

const series = computed(() => [
  { 
    name: "Weight",
    data: userInfo.value.cleanEntries.map(item => [parseDate(item.date), item.weight]),
  },
]);

const chartOptions = {
  chart: {
    zoom: {
      enabled: false
    }
  },
  dataLabels: {
    enabled: false
  },
  stroke: {
    curve: 'straight'
  },
  title: {
    text: 'Weight Change',
    align: 'left'
  },
  xaxis: {
    type: 'datetime',
  },
  yaxis: {
    opposite: true
  },
  legend: {
    horizontalAlign: 'left'
  }
};
</script>

<style lang="">
    
</style>